module.exports = {"dashboard":{"ng_blocks":["/gogovan/dashboard/hk/hk-dashboard.html"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/en_hk/setting/dashboard/setting.json
// module id = 596
// module chunks = 0 1 2 3 4 5